import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=2e618a9e&scoped=true"
import script from "./detailsPage.vue?vue&type=script&lang=js"
export * from "./detailsPage.vue?vue&type=script&lang=js"
import style0 from "./detailsPage.vue?vue&type=style&index=0&id=2e618a9e&prod&lang=scss"
import style1 from "./detailsPage.vue?vue&type=style&index=1&id=2e618a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e618a9e",
  null
  
)

export default component.exports